import React from 'react';
import './index.scss';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const NoCoupons = () => {
  return (
    <div className="noCouponsWrapper">
      <div className="noCouponsContainer">
        <LazyLoadImage
          src="/content/images/icons/noCoupons.svg"
          alt=""
          height="100px"
          width="100px"
        />
        <h3>No saved coupons</h3>
        <p className="mobile-only">
          Tap the button above to search for a coupon.
          <br />
          When you save a coupon, it will appear here.
        </p>
        <p className="desktop-only">
          Add to your saved drugs folder by searching
          <br />
          for prescriptions and clicking Save.
        </p>
      </div>
    </div>
  );
};

export default NoCoupons;
